import { useGlobalizationContext, useTranslation } from '@cs-cms/state-management';
import { CPS_ACTIONS_ALLOWED_FOR_DOCUMENT, PERMISSIONS_FIELD } from '@cs-cms/types';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import React from 'react';
import { CpsGridCell } from './CpsGridCell';

const getActionKey = (actionValue: number): string => {
  for (const key in CPS_ACTIONS_ALLOWED_FOR_DOCUMENT) {
    if (CPS_ACTIONS_ALLOWED_FOR_DOCUMENT[key as keyof typeof CPS_ACTIONS_ALLOWED_FOR_DOCUMENT] === actionValue) {
      return key.charAt(0) + key.slice(1).toLowerCase();
    }
  }
  return actionValue.toString();
};

export const ActionsCell: React.FC<GridCustomCellProps> = props => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);
  const actionsArray = props.dataItem[PERMISSIONS_FIELD] as number[];

  const hasOtherActions = actionsArray.some(value => value !== 0);
  const filteredActions = hasOtherActions ? actionsArray.filter(value => value !== 0) : actionsArray;

  const actionNames = filteredActions
    .map(value => {
      const actionKey = getActionKey(value);
      return translate(`grid.filter${actionKey}`);
    })
    .join(', ');

  return (
    <CpsGridCell
      dataItem={props.dataItem}
      field={props.field}
      dataIndex={props.dataIndex}
      id={props.id}
      tdProps={props.tdProps}
      columnPosition={props.columnPosition}
      onChange={props.onChange}
      className={props.className}
      colSpan={props.colSpan}
      ariaColumnIndex={props.ariaColumnIndex}
      isSelected={props.isSelected}
      style={props.style}
      rowType={props.rowType}
      level={props.level}
      expanded={props.expanded}
      title=""
    >
      {actionNames}
    </CpsGridCell>
  );
};
